import { fetchAuthSession } from 'aws-amplify/auth';
import { useEffect, useState } from 'react';

export function useIsSupportUser(enabled: boolean): boolean {
  const [isSupportUser, setIsSupportUser] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setIsSupportUser(false);
      return;
    }

    let isCurrent = true;
    const checkSupportUser = async () => {
      try {
        const session = await fetchAuthSession();
        if (isCurrent) {
          setIsSupportUser(session.tokens?.idToken?.payload?.profile === 'SupportUser');
        }
      } catch (error) {
        if (isCurrent) {
          setIsSupportUser(false);
          // eslint-disable-next-line no-console -- authentication lookup failures should be visible
          console.error(error);
        }
      }
    };

    checkSupportUser();

    return () => {
      isCurrent = false;
    };
  }, [enabled]);

  return enabled && isSupportUser;
}
